<div
  class="notification"
  [ngClass]="{ closable: closable() }">
  <div class="notification__content">
    <div class="content__items">
      @if (icon() != null) {
        <mat-icon
          [fontSet]="icon().set"
          [fontIcon]="icon().name" />
      }

      <span>
        {{ text() }}
      </span>
    </div>

    <div class="content__items">
      @for (actionBtn of actions(); track $index) {
        <cgw-button
          [label]="actionBtn.label"
          [ariaLabel]="actionBtn.ariaLabel"
          [icon]="actionBtn.icon"
          (onClick)="actionBtn.action(); close()" />
      }
    </div>
  </div>

  @if (closable()) {
    <cgw-button-icon
      [icon]="{ name: 'close' }"
      label="Cerrar"
      (onClick)="close()" />
  }
</div>
